export const getters = {
  user: state => state.user,
  hasUser: state => state.user !== null,
  usersList: state => state.usersList
};
